// ----------------------------
// Created by Bulletproof Games
//            2017
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Options Button

optionsButtonEx = {};

optionsButtonEx.create = function () {
  var button = new PIXI.Container();

  this._sideMenuOpen = false;

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);
  InputHelpers.addInfoPlatformEnabledFlag(button);

  button.canEnable = function () {
    return this._flags.infoPlatformEnabled && this._sideMenuOpen;
  };

  button.canShow = function () {
    return this._flags.infoPlatformVisible;
  };

  button.onPressedCallback = function () {
    gameData.helpPageScroll.open();
    if (button.soundName !== "") button.playSound();
  };

  button.sideMenuOpenMsg = function () {
    this._sideMenuOpen = true;
  };

  button.sideMenuClosedMsg = function () {
    this._sideMenuOpen = false;
  };

  messageBus.subscribe(
    "game:sideMenuOpen",
    button.sideMenuOpenMsg.bind(button)
  );
  messageBus.subscribe(
    "game:sideMenuClosed",
    button.sideMenuClosedMsg.bind(button)
  );

  return button;
};

optionsButtonEx.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};
optionsButtonEx.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "optionsButtonEx",
  optionsButtonEx.create,
  optionsButtonEx.initialise,
  optionsButtonEx.getFilesRequired
);
